export const fieldErrors = {
    emailEmpty: 'Vänligen ange e-postadress',
    invalidEmail: 'Vänligen ange korrekt epostadress',
    phoneNumberEmpty: 'Vänligen ange mobilnummer',
    phoneNumber: 'Notera: enbart siffror är tillåtna i fältet för telefonnummer',
    phoneNumberFormat: 'Vänligen ange mobilnummer i rätt format 07xxxxxxxx',
    terms: 'Du måste godkänna våra villkor innan du kan gå vidare!',
    nameOnCard: 'Vänligen ange namn',
    userAlreadyPremium: 'Du är redan premiumkund. Inget nytt köp behövs.',
    userAlreadyPremiumWithPhone: 'Ditt telefonnummer registrerar dig redan hos oss och du är premiumkund.',
    loginDetailEmp: 'Please enter details',
    incorrectLogin: 'Felaktigt email eller lösenord',
    noUserFound: 'Användare finns inte',
    noPurchase : 'Mina sidor är en tjänst för dig som köpt en prenumeration direkt här på hemsidan',
    resetpasswordEmailSent: 'Ett email med nytt lösenord kommer snart.',
    smsNotSent: 'Kunde inte SMS till ditt nr',
    smsSent: 'SMS skickades till ditt telefonnr',
    updateCardSuccess: 'Kortet har uppdaterats',
    updateCardFail: 'Kortuppdatering misslyckas',
    cancelReson: 'Ange anledning så att vi kommer att förbättra det',
    klarna_authfail: 'betalningsmetoden misslyckades, försök igen efter någon gång',
    authFail: 'Payment authentication Failed',
    fillCard: 'Fyll i dina kortuppgifter',
    paymentFaild: 'betalningen misslyckades, försök igen och kontrollera dina uppgifter',
    emailDomain: 'Vänligen dubbellkolla även din skräppost för Alberts välkomstmail.',
    subNotCancelle: 'Oops! Tekniskt fel uppstod. Vänligen kontakta vårt supportteam på support@hejalbert.se så avslutar vi prenumerationen åt dig på studs!',
    campaignEmpty: 'Campaign is empty or not received',
    stripeToeknEmpty: 'Stripe token is empty or not receive',
    emailEmpty: 'E-postmeddelandet är tomt eller inte mottaget',
    stripeUserNotCreated: 'Could not create stripe customer',
    stripeSubscriptionNotCreated: 'Could not create stripe subscription',
    invalidData: 'Vissa data saknas',
    passwordEmpty: 'Lösenordet är tomt eller inte mottaget',
    passwordLimit: 'Minsta lösenordsgräns är 6!',
    
};


export const stripeErrors = {
    // Stripe error codes
    invalid_number: 'Det angivna kortnumret verkar inte stämma.',
    invalid_expiry_month: 'Giltighetsmånad eller år verkar ha blivit fel.',
    invalid_expiry_year: 'Giltighetsmånad eller år verkar ha blivit fel.',
    invalid_cvc: 'Den angivna tresiffriga säkerhetsnumret är fel',
    incorrect_number: 'Det angivna kortnumret verkar inte stämma.',
    expired_card: 'Kortets giltighetstid verkar ha passerats.',
    card_declined: 'Betalningen nekades av bank.',
    processing_error: 'Tekniskt fel. Vänligen prova igen.',
    incomplete_cvc: 'Ditt korts säkerhetskod verkar inte vara fullständigt.',
    incomplete_zip: 'Det angivna postnumret verkar inte vara fullständigt. ',
    incomplete_number: 'Det angivna kortnumret verkar inte stämma. Vänligen dubbelkolla uppgifterna och prova igen.',
    incomplete_expiry: 'Ditt korts utgångsdatum är ofullständigt.',
    invalid_expiry_year_past: 'Ditt korts utgångsår är tidigare.',
    incomplete_expiry: 'Ditt korts utgångsdatum är ofullständigt.',
  };